import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Message, List } from 'semantic-ui-react';
import { ModalTemplate, Loading, Button as Btn } from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './AdminTargetDelete.css';
const cx = classNames.bind(styles);

class AdminTargetDelete extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { deleting, targetInfo, removeTarget, handleOnToggleDeleteModal } = this.props;
    const { targetNo, targetName, regEpoch } = targetInfo;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-admin tiny', 'common-content')}
        closeIcon
        onToggleModal={handleOnToggleDeleteModal}
        visible
        header={
          <div>{defineMessages(formatMessage({ id: 'AdminTargetInTableMenu_2', defaultMessage: '대상자 삭제' }))}</div>
        }
        buttons={
          <div className={cx('inline-block')}>
            <Btn buttonColor="#bbbbbb" onClick={handleOnToggleDeleteModal}>
              {defineMessages(formatMessage({ id: 'AdminUserDelete_2', defaultMessage: '취소' }))}
            </Btn>
            <Btn className={cx('gray-button')} loading={deleting} disabled={deleting} onClick={removeTarget}>
              {defineMessages(formatMessage({ id: 'AdminUserDelete_3', defaultMessage: '삭제' }))}
            </Btn>
          </div>
        }>
        <Loading
          active={deleting}
          size="small"
          content={defineMessages(formatMessage({ id: 'AdminUserDelete_4', defaultMessage: '삭제중...' }))}
        />
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'AdminTargetInTableMenu_5',
              defaultMessage: '다음 대상자를 삭제하시겠습니까?'
            })
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          <div className={cx('template-detail')}>
            <List bulleted className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>No</div>
                {targetNo}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'AdminTargetInTableMenu_3', defaultMessage: '대상자명' }))}
                </div>
                {targetName}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'AdminTargetInTableMenu_4', defaultMessage: '등록일시' }))}
                </div>
                {common.timeFormatFromUTCEpoch(regEpoch)}
              </List.Item>
            </List>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

export default injectIntl(AdminTargetDelete);



// WEBPACK FOOTER //
// ./src/script/components/admin/target/AdminTargetDelete.js